/* Haven Print Co. — "Add a message inside" for greeting cards (+$2 add-on).
   1) Product page: tick box, live preview, and when ticked the add-to-cart sends
      the card (with the message) AND the $2 "card-message-inside" item together.
   2) Cart: keeps the $2 item's quantity equal to its card, and removes it if the card is removed. */
(function () {
  if (window.__hpmLoaded) return;
  window.__hpmLoaded = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ADDON_HANDLE = 'card-message-inside';
  var KEY_PROP = '_hp_msg';
  var MSG_PROP = 'Message inside';

  function uid() { return 'm' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }

  /* ---------------- product page ---------------- */
  function setup(box) {
    if (box.__hpm) return; box.__hpm = true;
    var form = box.closest('form');
    var check = box.querySelector('[data-hpm-check]');
    var panel = box.querySelector('[data-hpm-panel]');
    var text = box.querySelector('[data-hpm-text]');
    var keyInput = box.querySelector('[data-hpm-key]');
    var count = box.querySelector('[data-hpm-count]');
    var msg = box.querySelector('[data-hpm-msg]');
    var err = box.querySelector('[data-hpm-error]');
    var max = +box.dataset.max || 250;
    if (!form || !check) return;

    function showError(t) {
      err.textContent = t || ''; err.hidden = !t;
      box.classList.toggle('is-error', !!t);
    }
    function render() {
      var v = text.value;
      count.textContent = v.length + ' / ' + max;
      msg.innerHTML = '';
      if (v.trim()) { msg.textContent = v; }
      else { var g = document.createElement('span'); g.className = 'hpm__ghost'; g.textContent = 'Your message will appear here'; msg.appendChild(g); }
      if (v.trim()) showError('');
      // warn if the text would run off the card
      requestAnimationFrame(function () {
        if (v.trim() && msg.scrollHeight > msg.clientHeight + 2) showError('That’s a little long to fit nicely. Try a few fewer lines.');
      });
    }
    function toggle() {
      var on = check.checked;
      box.classList.toggle('is-on', on);
      panel.hidden = !on;
      text.disabled = !on;
      keyInput.disabled = !on;
      if (on) {
        keyInput.value = uid(); render();
        // Desktop: jump straight into typing. Phones: don't pop the keyboard; just bring the box into view.
        if (window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) text.focus({ preventScroll: true });
        else setTimeout(function () { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 60);
      }
      else showError('');
    }
    check.addEventListener('change', toggle);
    text.addEventListener('input', render);

    // Block add-to-cart if ticked but empty (runs before the theme's submit handler).
    document.addEventListener('submit', function (e) {
      if (e.target !== form || !check.checked) return;
      if (!text.value.trim()) {
        e.preventDefault(); e.stopImmediatePropagation();
        showError('Type your message, or untick “Add a message inside”.');
        // The sticky add-to-cart bar on phones can be far below, so bring the box into view.
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { text.focus({ preventScroll: true }); }, 350);
      } else {
        keyInput.value = uid(); // fresh link for every add
      }
    }, true);

    // Rewrite what the theme sends to /cart/add: card + $2 add-on, linked by a hidden key.
    form.addEventListener('formdata', function (e) {
      if (!check.checked || !text.value.trim()) return;
      var fd = e.formData;
      var id = fd.get('id');
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      if (!id) return;
      var props = [];
      fd.forEach(function (val, name) {
        var m = /^properties\[(.+)\]$/.exec(name);
        if (m) props.push([m[1], val]);
      });
      var key = keyInput.value || uid();
      ['id', 'quantity'].forEach(function (n) { fd.delete(n); });
      props.forEach(function (p) { fd.delete('properties[' + p[0] + ']'); });
      fd.append('items[0][id]', id);
      fd.append('items[0][quantity]', qty);
      props.forEach(function (p) { fd.append('items[0][properties][' + p[0] + ']', p[1]); });
      fd.append('items[1][id]', box.dataset.addonVariant);
      fd.append('items[1][quantity]', qty);
      fd.append('items[1][properties][For]', box.dataset.cardTitle);
      fd.append('items[1][properties][' + KEY_PROP + ']', key);
    });
  }
  function scan() { document.querySelectorAll('[data-hpm]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------------- cart sync ---------------- */
  var busy = false, again = false;
  function isAddon(item) { return item.handle === ADDON_HANDLE; }

  function renderSections(sections) {
    if (!sections) return;
    var parse = function (html, sel) { var n = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return n ? n.innerHTML : null; };
    var d = document.getElementById('Cart-Drawer');
    if (d && sections['cart-drawer']) {
      var inner = parse(sections['cart-drawer'], '.cart-drawer');
      if (inner !== null) {
        d.innerHTML = inner;
        if (typeof CartDrawer !== 'undefined') {
          try { var cd = Object.create(CartDrawer.prototype); cd.container = d; cd.removeProductEvent(); cd.notesToggle(); cd.termsCheckbox(); } catch (e) { }
        }
      }
    }
    var t = document.getElementById('cart-drawer-toggle');
    if (t && sections['cart-bubble']) {
      var c = parse(sections['cart-bubble'], '.thb-item-count');
      var target = t.querySelector('.thb-item-count') || t;
      if (c !== null) target.innerHTML = c;
    }
  }

  function syncCart() {
    if (busy) { again = true; return; }
    busy = true;
    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cards = {}, updates = {}, changed = false;
        cart.items.forEach(function (it) {
          var k = it.properties && it.properties[KEY_PROP];
          if (k && !isAddon(it)) cards[k] = (cards[k] || 0) + it.quantity;
        });
        cart.items.forEach(function (it) {
          if (!isAddon(it)) return;
          var k = it.properties && it.properties[KEY_PROP];
          var want = (k && cards[k]) || 0;
          if (it.quantity !== want) { updates[it.key] = want; changed = true; }
        });
        if (!changed) return;
        var onCartPage = !!document.getElementById('Cart');
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-bubble', sections_url: location.pathname })
        }).then(function (r) { return r.json(); }).then(function (j) {
          renderSections(j.sections);
          if (onCartPage) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .catch(function () { })
      .finally(function () { busy = false; if (again) { again = false; syncCart(); } });
  }

  // Watch the theme's own cart requests and re-check after each one.
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(change|update|clear)/.test(url) && !(init && init.__hpm)) {
      p.then(function () { setTimeout(syncCart, 50); }, function () { });
    }
    return p;
  };

  if (window.__hpmCartHasMsg) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCart); else syncCart();
  }
})();
